<template>
        <div>
        <!-- Loading Message -->
        <p v-if="!dataLoaded">Loading</p>
        
        <!-- Loaded Data -->
        <div v-if="dataLoaded">
            <button @click="editMode = !editMode">Edit</button>
        
            <!-- Edit View -->
            <form v-if="editMode" v-on:submit.prevent>
                <div class="row">
                    <div class="column">
                        <label>ID</label><input type="number" v-model="lockerModule.id" readonly>
                        <label>Name</label><input type="text" v-model="lockerModule.name">
                        <label>Price ($)</label><input type="number" step="0.01" v-model="lockerModule.price">
                        <label>Is A Kiosk?</label><input type="checkbox" v-model="lockerModule.is_kiosk">
                    </div>
                    <div class="column">
                        <label>Number of Lockers</label><input type="number" v-model="lockerModule.num_lockers">
                        <label>Height (mm)</label><input type="number" v-model="lockerModule.height"/>
                        <label>Width (mm)</label><input type="number" v-model="lockerModule.width"/>
                        <label>Depth (mm)</label><input type="number" v-model="lockerModule.depth"/>
                    </div>
                </div>
                <button @click="updateModule">Save</button>
            </form>

            <!-- Regular View -->
            <div v-if="!editMode">
                <!-- Module Details -->
                <div class="row">
                    <div class="column">
                        <p><b>ID</b> {{ lockerModule.id }}</p>
                        <p><b>Name</b> {{ lockerModule.name }}</p>
                        <p><b>Price</b> ${{ lockerModule.price.toFixed(2) }}</p>
                        <p><b>Module Type</b> {{ lockerModule.is_kiosk ? "Kiosk":"Module"}}</p>
                    </div>
                    <div class="column">
                        <p><b>Number of Lockers</b> {{ lockerModule.num_lockers }}</p>
                        <p><b>Height</b> {{ lockerModule.height }}mm</p>
                        <p><b>Width</b> {{ lockerModule.width }}mm</p>
                        <p><b>Depth</b> {{ lockerModule.depth }}mm</p>
                    </div>
                </div>

            </div>
        </div><!-- DataLoaded -->
    </div>
</template>

<script>
import {CallApi} from '../Utilities.js'

export default {
    name: 'ModuleDetail',
    watch: {
        '$route': 'fetchData'
    },
    data: function() {
        return {    
            editMode: false,
            dataLoaded: false,
            lockerModule: {},
        }
    },
    methods: {
        fetchData: async function() {
            const apiResponse =  await CallApi('GET', `/modules/${this.$route.params.id}`)
            this.lockerModule  = apiResponse.module
            this.dataLoaded = true
            this.editMode = false
            
        },
        updateModule: async function() {
            // Do Update
            await CallApi("POST", `/modules/${this.lockerModule.id}`, this.lockerModule)
            
            // Retrieve Updated Data
            this.fetchData()
        }
    },
    mounted() { this.fetchData() }
}
</script>